var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000108276159 0.5238 15.814 0.5238 15.814 9.9998 0.000108276159 9.9998"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.477160)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9072,8.6718 C6.0232,8.6718 4.4962,7.1448 4.4962,5.2618 C4.4962,3.3778 6.0232,1.8498 7.9072,1.8498 C9.7902,1.8498 11.3172,3.3778 11.3172,5.2618 C11.3172,7.1448 9.7902,8.6718 7.9072,8.6718 M15.6892,4.9438 C13.7272,2.3328 11.0202,0.5238 7.9012,0.5238 C4.7882,0.5238 2.0792,2.3168 0.1242,4.9288 C-0.0988,5.2268 0.0332,5.4628 0.1022,5.5608 C1.9812,8.2758 4.7742,9.9998 7.9012,9.9998 C11.0462,9.9998 13.8532,8.2538 15.7352,5.5138 C15.7902,5.4288 15.9022,5.2268 15.6892,4.9438",
    id: "Fill-1",
    fill: "white",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9062,4.13716 C7.0242,4.13716 6.3052,4.85516 6.3052,5.73816 C6.3052,6.62016 7.0242,7.33816 7.9062,7.33816 C8.7892,7.33816 9.5072,6.62016 9.5072,5.73816 C9.5072,4.85516 8.7892,4.13716 7.9062,4.13716",
    id: "Fill-4",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsContrast);
export default __webpack_public_path__ + "static/media/details-contrast.dc42c09703b8af31569dbd38b6164308.svg";
export { ForwardRef as ReactComponent };